/**
 * files.ts — Helpers de manipulação de arquivos
 * Extraído de Chat.tsx e ChatHubPage.tsx (código duplicado)
 */

/** Converte File para data URL (base64) */
export function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
